function handlerFromInput(input) {
    if (typeof input === 'function')
        return input;
    return ((...args) => {
        const [ctx, ...rest] = args;
        return input.run(ctx, ...rest);
    });
}
function dependenciesFromInput(input) {
    return typeof input === 'function' ? [] : input.dependencies;
}
function fragment(hook, handler, options = {}) {
    const dependencies = Object.freeze([...(options.dependencies ?? [])]);
    return Object.freeze({
        source: 'game_card_ability',
        hook,
        ...(options.abilityId === undefined ? {} : { abilityId: options.abilityId }),
        dependencies,
        compile: () => handler,
    });
}
function reactiveFragment(hook, input) {
    return fragment(hook, handlerFromInput(input), { dependencies: dependenciesFromInput(input) });
}
export const onPlay = (input) => reactiveFragment('onPlay', input);
export const onEnterPlay = (input) => reactiveFragment('onEnterPlay', input);
export const onLeavePlay = (input) => reactiveFragment('onLeavePlay', input);
export const onDeath = (input) => reactiveFragment('onDeath', input);
export const onBeforeCombat = (input) => reactiveFragment('onBeforeCombat', input);
export const onDealDamage = (input) => reactiveFragment('onDealDamage', input);
export const onTakeDamage = (input) => reactiveFragment('onTakeDamage', input);
export const onAttack = (input) => reactiveFragment('onAttack', input);
export const onAttackResolved = (input) => reactiveFragment('onAttackResolved', input);
export const onAttacked = (input) => reactiveFragment('onAttacked', input);
export const onAfterCombat = (input) => reactiveFragment('onAfterCombat', input);
export const onRoundStart = (input) => reactiveFragment('onRoundStart', input);
export const onRoundEnd = (input) => reactiveFragment('onRoundEnd', input);
export const onAnyEvent = (input) => reactiveFragment('onAnyEvent', input);
export const onHackTriggered = (handler) => fragment('onHackTriggered', handler);
export const beforeOwnAttackRaw = (handler) => fragment('beforeOwnAttack', handler);
export const interceptAttack = (handler) => fragment('interceptAttack', handler);
export const beforeAlliedAttackRaw = (handler) => fragment('beforeAlliedAttack', handler);
export const interceptIncomingDamage = (handler) => fragment('interceptIncomingDamage', handler);
export const modifyOutgoingDamage = (handler) => fragment('modifyOutgoingDamage', handler);
export const modifyIncomingDamage = (handler) => fragment('modifyIncomingDamage', handler);
export const replaceDamage = (handler) => fragment('replaceDamage', handler);
export const replaceDeath = (handler) => fragment('replaceDeath', handler);
export const planReactionTrigger = (handler) => fragment('planReactionTrigger', handler);
//# sourceMappingURL=fragments.js.map